var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "198.83px",
    viewBox: "0 0 1030 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M947.2 345.6h-281.6V76.8C665.6 32 627.2 0 588.8 0H441.6c-44.8 0-76.8 32-76.8 76.8v268.8H76.8C32 345.6 0 384 0 422.4v57.6c0 44.8 32 76.8 76.8 76.8v390.4c0 44.8 32 76.8 76.8 76.8h729.6c44.8 0 76.8-32 76.8-76.8V556.8c38.4 0 70.4-32 70.4-70.4v-64c-6.4-38.4-38.4-76.8-83.2-76.8z m-518.4 0V102.4c0-19.2 19.2-38.4 38.4-38.4h89.6c19.2 0 38.4 19.2 38.4 38.4v243.2H428.8z m422.4 614.4h-89.6v-134.4c0-19.2-12.8-32-32-32s-32 12.8-32 32V960H550.4v-134.4c0-19.2-12.8-32-32-32s-32 12.8-32 32V960H339.2v-134.4c0-19.2-12.8-32-32-32s-32 12.8-32 32V960H179.2c-19.2 0-38.4-19.2-38.4-38.4V563.2h748.8v352c0 25.6-19.2 44.8-38.4 44.8z m70.4-460.8H102.4c-19.2 0-38.4-19.2-38.4-38.4v-6.4c0-19.2 19.2-38.4 38.4-38.4h812.8c19.2 0 38.4 19.2 38.4 38.4v6.4c6.4 19.2-12.8 38.4-32 38.4z",
    fill: "#0076FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.42da68b2400366a5ebb622933e28328c.svg";
export { ForwardRef as ReactComponent };